import { useState, useContext, useEffect } from 'react';

import Error from 'components/common/forms/Error';
import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';
import FunnelHeader from 'components/signUpFunnel/shared/FunnelHeader';
import { HOME_CHEF } from 'context/BrandContext';
import useAnalyticsEffect from 'hooks/useAnalyticsEffect';
import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import usePartnershipQuery from 'hooks/usePartnershipQuery';
import TMNTBadge from 'images/signUpFunnel/tmnt-badge.gif';
import TMNTFreeToy from 'images/signUpFunnel/tmnt-free-toy.png';
import TMNTTextMobile from 'images/signUpFunnel/tmnt-pick-plans-text-mobile.png';
import TMNTText from 'images/signUpFunnel/tmnt-pick-plans-text.png';
import { FAMILY, TMNT, PAGE_VIEW_EVENT } from 'lib/constants';
import RequestService from 'services/RequestService';

import PlanCards from './PlanCards';

const PickPlanContainer = () => {
  const { user } = useContext(UserContext);
  const [error, setError] = useState(null);
  const mealPlanSlug = useFunnelMealPlan();
  const isFamilyMealPlan = mealPlanSlug === FAMILY;
  const { data: partnershipData } = usePartnershipQuery(user?.partnerReferrer);

  const isTMNT = partnershipData?.partnership?.name === TMNT;

  useEffect(() => {
    RequestService.v3.createEvents({ params: { eventName: PAGE_VIEW_EVENT } });
  }, []);

  useAnalyticsEffect(({ events, logEvent }) => {
    const planViewEvent = isFamilyMealPlan ? 'plans_family' : 'plans_core';
    logEvent(events.signUp[HOME_CHEF][planViewEvent].viewed, {});
  }, []);

  return (
    <div className="mx-6 mt-6 rounded text-center bp2:mx-auto bp2:mt-12">
      <FunnelHeader
        title="Pick your plan"
        subtitle="You can change your plan at any time."
        containerClassName="text-left"
      ></FunnelHeader>
      {isTMNT && (
        <div className="my-4 flex h-[58px] flex-row items-center justify-between rounded bg-[#8DC63F] px-2 bp2:px-6">
          <img src={TMNTFreeToy} alt="TMNT Free Toy" className="h-[64px] w-[78px] bp1:h-[90px]" />
          <div className="flex min-w-0 flex-1 items-center justify-center px-1">
            <img
              src={TMNTText}
              alt="TMNT Text"
              className="hidden w-full max-w-[448px] object-contain bp1:block"
            />
            <img
              src={TMNTTextMobile}
              alt="TMNT Text"
              className="block w-full max-w-full object-contain bp1:hidden"
            />
          </div>
          <img src={TMNTBadge} alt="TMNT Badge" className="w-[58px] " />
        </div>
      )}
      <div className="mt-4 bp2:mt-6">
        <PlanCards
          recommendedMealPlan={user?.recommendedMealPlan}
          setError={setError}
          mealPlanSlug={mealPlanSlug}
          isFamilyMealPlan={isFamilyMealPlan}
        />
      </div>
      {isTMNT && (
        <Text className="textXs mr-auto max-w-[700px] text-left text-charcoal-90">
          The free Teenage Mutant Ninja Turtle (“TMNT”) toys are only available during the
          promotional period and while supplies last. Customers must use a specific TMNT promotional
          code during the promotional period in order to receive a toy. The free TMNT toys are not
          suitable for children under the age of 3. The appearance and design of the free toy may
          vary. Visit{' '}
          <a href="/TMNT" className="text-charcoal-90 underline">
            homechef.com/TMNT
          </a>{' '}
          for full terms and conditions.{' '}
          <span className="block">© 2026 Viacom International Inc.</span>
        </Text>
      )}
      {error && <Error message={error} />}
    </div>
  );
};

export default PickPlanContainer;
